















































import CompanyUserRequired from "@/components/CompanyRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import {DateTime} from "@/modules/models";
import {PersonsHseGuidelineConfirmedReportResult} from "@/modules/reportmodels";
import rd from "@/modules/vRoutedefs";
import Api from "@/components/location/Api";

const left = "left";

@Component
export default class PersonsHseGuidelineConfirmedReport extends CompanyUserRequired {
  @Inject()
  api!: Api;

  @Prop()
  locationId!: number;

  result: PersonsHseGuidelineConfirmedReportResult | null = null;
  loading = false;

  @Watch("hseGuidelineId", {immediate: true})
  async onHseGuidelineIdChanged() {
    if(this.locationId > 0) {
      this.loading = true;
      try {
        this.result = await this.api.confirmedHseGuidelineReport(this.locationId);
      } finally {
        this.loading = false;
      }
    }
  }

  get locationTo() {
    return {name: rd.locations.location.name, params: {locationId: this.locationId}};
  }

  get guidelineTitle() {
    return this.result != null ? this.result.guideline.title : "";
  }
  get guidelineVersion() {
    return  this.result != null ? this.result.guideline.version : 0;
  }

  headers = [
    {text: "", sortable: false, width: 1},
    {text: "Fornavn", value: "personFirstName", align: left},
    {text: "Etternavn", value: "personLastName", align: left},
    {text: "Født", value: "personBirthDate", align: left},
  ];

  confirmedHeaders = [
    ...this.headers,
    {text: "Bekreftet", value: "confirmedTs", align: left},
  ];

  unconfirmedHeaders = [
    ...this.headers,
    {text: "Sist registrert inn", value: "lastRegInTs", align: left},
  ];

  get confirmedLines() {
    return this.result != null ? this.result.confirmed : [];
  }

  get notConfirmedLines() {
    return this.result != null ? this.result.notConfirmed : [];
  }

  formatDate(dt: DateTime): string | null {
    return dt != null ? dt.toLocalDate() : null;
  }
  personTo(guid: string) {
    return {name: rd.users.name, query: {guid: guid}};
  }

}
